import type { EmailDomainRecord, MailboxConnection } from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export function getDeliverabilityOverview(): Promise<{
  mailboxes: Array<
    Pick<
      MailboxConnection,
      | "mailboxId"
      | "emailAddress"
      | "provider"
      | "status"
      | "isPrimary"
      | "dailySendLimit"
      | "hourlySendLimit"
      | "sentLast24h"
      | "sentLastHour"
      | "lastSyncAt"
    >
  >;
  stats: {
    scheduled: number;
    sent: number;
    replied: number;
    failed: number;
    draft: number;
    opened: number;
    clicked: number;
  };
  openTrackingEnabled: boolean;
  clickTrackingEnabled: boolean;
  trackingSubdomain: string;
  domains: EmailDomainRecord[];
}> {
  return apiGet("/api/deliverability/overview");
}

export function updateTrackingSettings(fields: {
  emailOpenTrackingEnabled?: boolean;
  emailClickTrackingEnabled?: boolean;
  emailTrackingSubdomain?: string;
}): Promise<{
  openTrackingEnabled: boolean;
  clickTrackingEnabled: boolean;
  trackingSubdomain: string;
}> {
  return apiPatch("/api/deliverability/tracking", fields);
}

export function listEmailDomains(): Promise<{ domains: EmailDomainRecord[] }> {
  return apiGet("/api/deliverability/domains");
}

export function addEmailDomain(
  domain: string,
): Promise<{ domain: EmailDomainRecord }> {
  return apiPost("/api/deliverability/domains", { domain });
}

export function verifyEmailDomain(
  domain: string,
): Promise<{ domain: EmailDomainRecord }> {
  return apiPost(
    `/api/deliverability/domains/${encodeURIComponent(domain)}/verify`,
    {},
  );
}

export function deleteEmailDomain(domain: string): Promise<void> {
  return apiDelete(
    `/api/deliverability/domains/${encodeURIComponent(domain)}`,
  );
}

export function listBounces(): Promise<{
  bounces: Array<{
    emailMessageId: string;
    subject: string;
    to: string[];
    status: string;
    reason?: string;
    at: string;
  }>;
}> {
  return apiGet("/api/deliverability/bounces");
}
